/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./button.component.less.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./button.component";
var styles_ButtonComponent = [i0.styles];
var RenderType_ButtonComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_ButtonComponent, data: {} });
export { RenderType_ButtonComponent as RenderType_ButtonComponent };
export function View_ButtonComponent_0(_l) { return i1.ɵvid(0, [i1.ɵncd(null, 0), (_l()(), i1.ɵeld(1, 0, null, null, 1, "span", [["class", "button__text"]], null, null, null, null, null)), i1.ɵncd(null, 1), i1.ɵncd(null, 2)], null, null); }
export function View_ButtonComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "button", [["ubl-button", ""]], [[1, "disable", 0]], null, null, View_ButtonComponent_0, RenderType_ButtonComponent)), i1.ɵdid(1, 49152, null, 0, i2.ButtonComponent, [], null, null)], null, function (_ck, _v) { var currVal_0 = i1.ɵnov(_v, 1).disableAttr; _ck(_v, 0, 0, currVal_0); }); }
var ButtonComponentNgFactory = i1.ɵccf("button[ubl-button]", i2.ButtonComponent, View_ButtonComponent_Host_0, {}, {}, [".before", "*", ".after"]);
export { ButtonComponentNgFactory as ButtonComponentNgFactory };
